<template>
  <component
    :is="submit ? 'button' : 'div'"
    :disabled="disabled"
    :class="[
      props.disabled
        ? [
            'bg-gray-secondary',
            'text-gray-primary',
            'border-[1px]',
            'border-gray-secondary',
            'cursor-not-allowed',
            'pointer-events-none',
          ]
        : ['button-hover cursor-pointer', newButtonStyle],
      props.isSmall
        ? 'py-[6.5px] text-button-secondary'
        : 'py-2 text-button-primary',
    ]"
    class="button-color inline-flex items-center justify-center gap-1 text-nowrap rounded-[5px] px-4"
  >
    <XIcon
      v-if="color === 'red' && newStyle"
      :class="props.isSmall ? 'h-3 w-3' : 'h-4 w-4'"
    />
    <AcceptIcon
      v-else-if="(color === 'green' || color === 'gray') && newStyle"
      :class="props.isSmall ? 'h-3 w-3' : 'h-4 w-4'"
    />
    <slot />
  </component>
</template>

<script setup lang="ts">
import { computed } from "vue";
import XIcon from "@/icons/x-icon.svg";
import AcceptIcon from "@/icons/accept-icon.svg";
import style from "@/style.json";

const props = withDefaults(
  defineProps<{
    color?: "green" | "red" | "blue" | "gray";
    submit?: boolean;
    disabled?: boolean;
    newStyle?: boolean;
    isSmall?: boolean;
  }>(),
  {
    color: "green",
    submit: false,
  },
);
const newButtonStyle = computed(() => {
  if (props.newStyle) {
    switch (props.color) {
      case "green":
        return "text-green-primary border-green-secondary border-[1px] hover:bg-green-opaced";
      case "red":
        return "text-red-primary border-red-secondary border-[1px] hover:bg-red-opaced";
      case "blue":
        return "text-white-primary border-white-secondary border-[1px]";
      case "gray":
        return "text-gray-secondary border-gray-secondary border-[1px]";
    }
  } else {
    switch (props.color) {
      case "green":
        return "hover:bg-green-primary bg-white-primary text-black-primary";
      case "red":
        return "hover:bg-red-primary bg-white-primary text-black-primary";
      case "blue":
        return "hover:bg-blue-primary bg-white-primary text-black-primary";
    }
  }
});
const shadow = computed(() => {
  switch (props.color) {
    case "green":
      return style.colors.green.opaced;
    case "red":
      return style.colors.red.opaced;
    case "blue":
      return style.colors.blue.opaced;
  }
});
</script>

<style scoped>
.button-color {
  transition:
    background-color 0.3s ease,
    box-shadow 0.5s ease;
}

.button-hover:hover {
  box-shadow: 0px 0px 16px 0px v-bind("shadow");
}

.button-color {
  transition-property: background-color, color, box-shadow;
  transition-timing-function: cubic-bezier(0.33, 1, 0.68, 1);
  transition-duration: 0.6s;
}
</style>
